<uni-search
  [showOptions]="true"
  placeholder="Search Competitions on UNI"
  (filter)="openFilterDialog()"
  (sort)="openSortDialog()"
  (searchedText)="addSearchText($event)"
  [orderTitle]="orderTitle">
</uni-search>

<div fxLayout="row" class="relative margin-y-3">
  <section
    class="width-100 overflow-hidden"
    fxLayout="row"
    [ngStyle]="{ padding: showScroll ? '0 60px' : '0' }"
    #tabsContent>
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-chip-list #chipList aria-label="Search results" class="search-chip-list">
        <mat-chip
          *ngFor="let query of searchQuery"
          [selectable]="selectable"
          [removable]="removable"
          class="chip-section">
          {{ query | titlecase }}
          <i class="icon-cross font-sm" (click)="removeSearchText(query)" *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngFor="let discipline of selectedDisciplines"
          [selectable]="selectable"
          [removable]="removable"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800" *ngIf="discipline">Discipline: </span>
          </p>
          {{ discipline.name | titlecase }}
          <i
            class="icon-cross font-sm"
            (click)="removeDiscipline(discipline)"
            *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngFor="let location of selectedLocations"
          [selectable]="selectable"
          [removable]="removable"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800">Location: </span>
            {{ location.name | titlecase }}
          </p>
          <i class="icon-cross font-sm" (click)="removeLocation(location)" *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngFor="let tag of selectedTags"
          [selectable]="selectable"
          [removable]="removable"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800">Category: </span> {{ tag.name | titlecase }}
          </p>
          <i class="icon-cross font-sm" (click)="removeTag(tag)" *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngIf="selectedRegistrationDateRange"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeRegistrationDateRange()"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800">Registration date range: </span>
          </p>
          {{ selectedRegistrationDateRange }} ({{ registrationDateRange }})
          <i
            class="icon-cross font-sm"
            (click)="removeRegistrationDateRange()"
            *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngIf="selectedSubmissionDateRange"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeSubmissionDateRange()"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800">Submission date range: </span>
          </p>
          {{ selectedSubmissionDateRange }} ({{ submissionDateRange }})
          <i class="icon-cross font-sm" (click)="removeSubmissionDateRange()" *ngIf="removable"></i>
        </mat-chip>
      </mat-chip-list>
    </div>
  </section>
  <div class="absolute cursor-pointer height-100" fxLayout="row" style="left: 0" *ngIf="showScroll">
    <i
      class="icon-arrow-left"
      style="background: #f4f4f4; font-size: 32px; line-height: 48px"
      (click)="scroll('left')"></i>
    <div
      class=""
      style="
        background: linear-gradient(to right, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%);
        width: 32px;
      "></div>
  </div>
  <div
    class="absolute cursor-pointer height-100"
    fxLayout="row"
    style="right: 0"
    *ngIf="showScroll">
    <div
      class=""
      style="
        background: linear-gradient(to left, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%);
        width: 32px;
      "></div>
    <i
      class="icon-arrow-right"
      style="background: #f4f4f4; font-size: 32px; line-height: 48px"
      (click)="scroll('right')"></i>
  </div>
</div>

<section
  class="comp-card-secton height-100 sparro-bg-white border-radius-3 padding-y-3 padding-x-2">
  <ng-container *ngIf="isLoading; else viewTemplate">
    <uni-skeleton-loader appearance="competition" [count]="4" [alignCenter]="true">
    </uni-skeleton-loader>
    <!-- <div fxLayout="row" fxLayoutAlign="center center" class="width-100" style="height:60vh">
      <uni-loader></uni-loader>
    </div> -->
  </ng-container>
  <ng-template #viewTemplate>
    <ng-container *ngIf="filteredResults && filteredResults.length > 0; else noComp">
      <div fxLayout="row" fxLayoutAlign="center center" class="margin-top-3">
        <h1 class="margin-0 font-bold font-sm">
          Showing {{ searchResults }} of {{ totalCount }} search results
        </h1>
      </div>
      <div style="margin-top: 32px">
        <uni-competition-cards-group [competitions]="filteredResults" align="center">
        </uni-competition-cards-group>
      </div>
      <!-- <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:30px" *ngIf="!showSpinner || !next">
        <uni-state-button default="Load more" button_class="secondary" (click)="loadMore()" *ngIf="next">
        </uni-state-button>
      </div> -->
    </ng-container>
    <ng-template #noComp>
      <div fxLayout="row" fxLayoutAlign="center center" style="height: 60vh">
        <p class="sparro-grey-700 text-center">
          Nothing related found. Please search something else!
        </p>
      </div>
    </ng-template>
  </ng-template>
  <ng-container *ngIf="showSpinner">
    <div fxLayout="row" fxLayoutAlign="center center" class="height-100">
      <uni-loader></uni-loader>
    </div>
  </ng-container>
</section>
<uni-public-footer></uni-public-footer>
